/**
 * Config: APIs and URLs are read from .env only (Vite injects them as import.meta.env).
 * Set VITE_API_BASE and VITE_N8N_WEBHOOK_URL in frontend/.env — see .env.example.
 */
export const getApiBase = () => {
  let base = import.meta.env?.VITE_API_BASE ?? "";
  base = (typeof base === "string" ? base : "").replace(/\/+$/, "");
  // In dev, allow missing .env and default to localhost backend
  if (!base && import.meta.env?.DEV) base = "http://localhost:3005";
  if (!base) return "";
  return base.endsWith("/api") ? base : `${base}/api`;
};

export const getN8nWebhookUrl = () => {
  return import.meta.env?.VITE_N8N_WEBHOOK_URL ?? "";
};
